import { IOption } from '@/types/global.ts'
import { ILineChartSettings } from '@/pages/Dashboards/Charts/LineChart/lineChart.types.ts'

const drawType: IOption<ILineChartSettings['lineMode']>[] = [
  { title: 'Шаг', value: 'step' },
  { title: 'Линия', value: 'straight' },
  { title: 'Кривая', value: 'spline' },
]

const lineChartSettingsСonstants = { drawType }
export default lineChartSettingsСonstants
